document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector(".js-newsletter-form");
  if (!form) {
    return;
  }

  var input = form.querySelector('input[type="email"]');
  var msg = form.querySelector("[data-newsletter-msg]");
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var value = input.value.trim();
    var valid = emailPattern.test(value);

    form.classList.remove("is-success", "is-error");

    if (!valid) {
      form.classList.add("is-error");
      input.setAttribute("aria-invalid", "true");
      if (msg) {
        msg.textContent = value ? "Please enter a valid email address." : "Please enter your email address.";
      }
      input.focus();
      return;
    }

    // No email service is connected yet — set a real signup shortcode to
    // replace this demo confirmation with an actual subscription.
    input.removeAttribute("aria-invalid");
    form.classList.add("is-success");
    if (msg) {
      msg.textContent = form.getAttribute("data-success") || "You're subscribed. Thanks for reading!";
    }
    form.reset();
  });
});
